import { getPublicConfig } from '../../../../config/getPublicConfig';
import { createAlgoliaSearchService } from './createAlgoliaSearchService';

const config = getPublicConfig();
export const algoliaSearchService = createAlgoliaSearchService(
	config?.algoliaAppId ?? '',
	config?.algoliaReadOnlyApiKey ?? '',
	config?.algoliaContentIndex ?? '',
);
